// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.printDIV {
    position: fixed;
    top: 0px;
    left: -100%;
    max-width: 605px;
    color: black;
}

.documentationButtonIcon {
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/documentation/documentation.control.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".printDIV {\n    position: fixed;\n    top: 0px;\n    left: -100%;\n    max-width: 605px;\n    color: black;\n}\n\n.documentationButtonIcon {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
